import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { OrdemServicoService } from '../services/ordem-servico.service';
import { VeiculoService } from '../services/veiculo.service';
import { AuthService } from '../services/auth.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ordem-servico-edit',
  templateUrl: './ordem-servico-edit.component.html',
  styleUrls: ['./ordem-servico-edit.component.css'],
  animations: [loadingFade]
})
export class OrdemServicoEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public formulario_manutencao_id = null;

  public formFormularioManutencao: FormGroup;

  public veiculos = [];

  constructor(private route: ActivatedRoute,
    private fb: FormBuilder,
    private OrdemServicoSvc: OrdemServicoService,
    private veiculoServiceSvc: VeiculoService,
    private authSvc: AuthService,
    private router: Router) { }

  ngOnInit() {
    this.pegaVeiculos();
    this.criaForm();
    this.loading = true;

    this.route.params.subscribe(params => {
      if (params.id) {
        this.formulario_manutencao_id = params.id;
        // pega dados a partir do id
        this.OrdemServicoSvc.getFormularioManutencao(params.id).then((data: any) => {
          data.formulario_manutencao_hr_entrada = moment(data.formulario_manutencao_mecanico_data, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
          data.formulario_manutencao_hr_saida = moment(data.formulario_manutencao_socorrista_data, 'YYYY-MM-DD HH:mm:ss').format('HH:mm');
          data.formulario_manutencao_mecanico_data = moment(data.formulario_manutencao_mecanico_data, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');
          data.formulario_manutencao_socorrista_data = moment(data.formulario_manutencao_socorrista_data, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY');


          this.preencheForm(data);
          this.loading = false;
        });
      }
      else {
        this.loading = false;
      }
    });
  }

  criaForm() {
    this.formFormularioManutencao = this.fb.group({
      formulario_manutencao_id: null,
      formulario_manutencao_relato_socorrista: [null, Validators.required],
      formulario_manutencao_relato_mecanico: [null, Validators.required],
      formulario_manutencao_mecanico_receptor: [null, Validators.required],
      veiculo_id: [null, Validators.required],
      formulario_manutencao_data_gravacao: [null],
      formulario_manutencao_condutor_receptor: [null, Validators.required],
      formulario_manutencao_mecanico_data: [null, Validators.required],
      formulario_manutencao_hr_entrada: [null, Validators.required],
      formulario_manutencao_socorrista_data: [null, Validators.required],
      formulario_manutencao_hr_saida: [null, Validators.required]
    });

    let campos_data = ['formulario_manutencao_mecanico_data', 'formulario_manutencao_socorrista_data'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formFormularioManutencao.controls[campo].setValue(formatted);
				}
			});
		}
  }

  pegaVeiculos(){
    this.veiculoServiceSvc.getVeiculosActiveByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
      this.veiculos = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  preencheForm(dados) {
    this.formFormularioManutencao.setValue(dados);
  }

  enviaFormularioManutencao() {
    if (this.formFormularioManutencao.valid) {
      this.submitting = true;

      let toSend = this.formFormularioManutencao.value;
     
      toSend.formulario_manutencao_mecanico_data = toSend.formulario_manutencao_mecanico_data + ' ' + toSend.formulario_manutencao_hr_entrada.slice(0, -2) + ':' + toSend.formulario_manutencao_hr_entrada.slice(2);
      toSend.formulario_manutencao_socorrista_data = toSend.formulario_manutencao_socorrista_data + ' ' + toSend.formulario_manutencao_hr_saida.slice(0, -2) + ':' + toSend.formulario_manutencao_hr_saida.slice(2);
      if (this.formulario_manutencao_id === null) { // criar
        
        this.OrdemServicoSvc.criaFormularioManutencao(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Ordem de serviço cadastrada com sucesso!',
            onClose: () => {
              this.router.navigate(['home/ordemservico']);
            }
          });
        }).catch(err => {
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
          console.log(err);
        });
      }
      else { // editar
        this.OrdemServicoSvc.editaFormularioManutencao(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Ordem de serviço alterada com sucesso!',
            onClose: () => {
              this.router.navigate(['home/ordemservico']);
            }
          });
        }).catch(err => {
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
          console.log(err);
        });
      }
    }
    else{
      for( let field in this.formFormularioManutencao.controls){
        let campo = this.formFormularioManutencao.get(field);
        campo.markAsTouched();
      }
      Swal.fire({
        type: 'error',
        title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
      });
    }
  }

  invalid(nome) {
    let input = this.formFormularioManutencao.get(nome);
    return input.touched && input.invalid;
  }
}
